// if(typeof override_js == 'undefined'){
    
    document.addEventListener('DOMContentLoaded', runOnLoad);

    function runOnLoad() {
        updatePage(window.PLW.selected_or_first_available_variant_id);
        var default_payment_option = document.getElementById("PLW_purchase-option-deposit-input");
        
        if(default_payment_option != null){
          default_payment_option.checked = true;
          set_payment_option(default_payment_option);     
        }
    }

    function set_payment_option(th) {

        if (th.id === "PLW_purchase-option-full") {
    
          removeSellingPlanFormInputs(null);

          if(window.PLW.release_date_condition == "deposit"){
              document.getElementById("PLW-release-info").style.display = 'none';
          }

          if(window.PLW.show_help_text == "deposit"){
            document.getElementById("PLW-customer-info").style.display = 'none';
          }
          
        }
        else if (th.id === "PLW_purchase-option-deposit-input") {
          
            insertSellingPlanFormInputs(th.value);

          // show release date
          if(window.PLW.release_date_condition == "deposit" || window.PLW.release_date_condition == "always"){
            document.getElementById("PLW-release-info").style.display = 'block';
            
          }

          if(window.PLW.show_help_text == "deposit" || window.PLW.show_help_text == "always"){
            document.getElementById("PLW-customer-info").style.display = 'block';
          }
            
        }
    }

    function insertSellingPlanFormInputs(sellingPlanId) {
        
        const insertInput = (form, planId) => {
            form.querySelectorAll(`[name="selling_plan"][value]:not([value="${planId}"])`).forEach((input) => {
              if (input) {
                  input.remove();
              }
            });
            if (form.querySelector(`[name="selling_plan"][value="${planId}"]`))
            return;
            create({
            tag: "input",
            appendTo: form,
            attributes: {
                id: "selected-purchase-option",
                type: "hidden",
                name: "selling_plan",
                value: planId
            }
            });
        };
        const productForms = document.querySelectorAll('form[action*="/cart/add"]');
        productForms.forEach(async (form) => {
            const formVariantId = form.querySelector('input[name="id"]')?.value;
            let formProductId;
            if (!formVariantId) {
              formProductId = form.querySelector('input[name="product-id"]')?.value;
            }
            if (!formProductId) {
              formProductId = form.closest("product-form")?.querySelector(
                  'input[name="product-id"]'
              )?.value;
            }
            if (!formVariantId && !formProductId) {
            // const downpayPlanIds = (await downpaySellingPlans()).map((plan) => plan.id).map(fromGid);
            // if (downpayPlanIds.includes(sellingPlanId)) {
            //   insertInput(form, sellingPlanId);
            // }
            }
            
            insertInput(form, sellingPlanId);
            return;
          
            if (!formVariantId && window.PLW.product_id === formProductId) {
              insertInput(form, sellingPlanId);
              return;
            }
            if (formVariantId && window.PLW.selected_or_first_available_variant_id === formVariantId) {
              insertInput(form, sellingPlanId);
              return;
            }
        });
    }

    function create({ tag, appendTo, children = [], attributes = {}, events = {} }) {
        const element = document.createElement(tag);
        Object.entries(attributes).forEach(([key, value]) => {
            element[key] = value;
        });
        Object.entries(events).forEach(([key, value]) => {
            element.addEventListener(key, value);
        });
        if (appendTo) {
            appendTo.appendChild(element);
        }
        children.forEach((child) => element.appendChild(child));
        return element;
    }

    function removeSellingPlanFormInputs() {
        const sellingPlanInputs = document.querySelectorAll('[name="selling_plan"]');
        sellingPlanInputs.forEach((input) => {
            if (input) {
            input.remove();
            }
        });
    }

    var listenToProductFormChange = ({ onProductFormChange }) => {
        const productForms = document.querySelectorAll('form[action*="/cart/add"]');
        productForms.forEach((form) => {
        form.addEventListener("change", async (event) => {
            let variantId;
            if (event.target.tagName === "INPUT" && event.target.name === "id") {
            variantId = event.target.value;
            } else {
            variantId = await getCurrentSelectedVariantId();
            }
            if (variantId) {
            onProductFormChange(variantId);
            }
        });
        });
    
        document.addEventListener("theme:variant:change", async (event) => {
        const variantId = event.detail?.variant?.id;
        if (variantId) {
            let sellingPlanId = event.detail?.variant?.selling_plan_allocations[0]?.selling_plan_id;
            
            if (!sellingPlanId) {
            onProductFormChange(null);
            return;
            }
            onProductFormChange(variantId);
        }
        });
    };

    listenToProductFormChange({
    onProductFormChange: async (variantId) => {
        await updatePage(variantId);
    }
    });

    async function updatePage(variantId) {

    var PLW_block = document.getElementById('PLW-block');

      console.log(window.PLW.allocated_variant_id);

    if (window.PLW.allocated_variant_id.includes(variantId)) {
        PLW_block.style.display = 'block';
    }else{
        PLW_block.style.display = 'none';
    }
    
    }

    async function getCurrentSelectedVariantId() {
    const params = new URLSearchParams(location.search);
    const variantId = params.get("variant");
    if (variantId) {
        return variantId;
    }
    const product = await productData(window.downpay.product_id);
    return fromGid(product.variants.edges[0].node.id);
    }

    
// }
  